import { cn } from "@/lib/utils";

// Three glossy black spheres rendered in pure CSS — the recurring brand device.
// Used as a compact mark (in the header) and, at larger sizes, as an editorial anchor.
export function SphereMark({ size = 16, className, gap = 3, animate = false }) {
  const sphere = (s) => ({
    width: s,
    height: s,
    borderRadius: "9999px",
    background:
      "radial-gradient(circle at 32% 28%, #6b6b6b 0%, #1a1a1a 38%, #000 100%)",
    boxShadow: "0 1px 3px rgba(0,0,0,.35)",
    flexShrink: 0,
  });
  return (
    <span
      className={cn("inline-flex items-end", animate && "tw-float", className)}
      style={{ gap }}
      aria-hidden="true"
    >
      <span style={sphere(size)} />
      <span style={sphere(size * 1.28)} />
      <span style={sphere(size * 0.82)} />
    </span>
  );
}
